export default "__VITE_ASSET__DqscDpS2__"